// assets
// import { IconKey } from '@tabler/icons';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import ChatIcon from '@mui/icons-material/Chat';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined';

// import GroupRoundedIcon from '@mui/icons-material/GroupRounded';

// constant
const icons = {
  AdminPanelSettingsOutlinedIcon,
  ChatIcon,
  ReportProblemOutlinedIcon,
  ContactPhoneOutlinedIcon
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const community = {
  id: 'community',
  title: 'Community',
  type: 'group',
  userRoles: ['Super Admin'],
  children: [
    {
      check: 'view-posts',
      id: 'community-posts',
      title: 'Posts',
      type: 'item',
      url: '/community-posts',
      icon: icons.AdminPanelSettingsOutlinedIcon,
      breadcrumbs: false
    },
    {
      check: 'view-chats',
      id: 'community-chats',
      title: 'Chats',
      type: 'item',
      url: '/community-chats',
      icon: icons.ChatIcon,
      breadcrumbs: false
    },
    {
      check: 'view-posts',
      id: 'reported-posts',
      title: 'Reported Posts',
      type: 'item',
      url: '/reported-posts',
      icon: icons.ReportProblemOutlinedIcon,
      breadcrumbs: false
    },
    {
      check: 'view-chats',
      id: 'reported-chats',
      title: 'Reported Chats',
      type: 'item',
      url: '/reported-chats',
      icon: icons.ReportProblemOutlinedIcon,
      breadcrumbs: false
    },
    {
      check: 'view-chats',
      id: 'chat-violations',
      title: 'Chat Violations',
      type: 'item',
      url: '/chat-violations',
      icon: icons.ContactPhoneOutlinedIcon,
      breadcrumbs: false
    }
  ]
};

export default community;
